import { Navigate, useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { Card, Space, Typography } from "antd";

import { getLeaveById } from "../api/leaveAPI";
import { LeaveForm } from "../components/LeaveForm";

const { Title } = Typography;

const UpdateLeave = () => {
  const { id } = useParams();
  const leaveId = id;

  const { data: leaveData, isLoading } = useQuery({
    queryKey: ["leave", leaveId],
    queryFn: () => getLeaveById(leaveId),
    enabled: !!leaveId,
  });

  if (!leaveId) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Update Leave
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          Leave Information
        </Title>

        {!isLoading && (
          <LeaveForm
            initialData={{
              ...leaveData,
              leaveType: leaveData.leaveType,
              startDate: leaveData.startDate,
              endDate: leaveData.endDate,
              reason: leaveData.reason,
              totalDays: leaveData.totalDays,
              fileUrl: leaveData.fileUrl,
            }}
            mode="update"
            leaveId={leaveId}
          />
        )}
      </Card>
    </Space>
  );
};

export default UpdateLeave;
